import React from 'react';
import { useTranslation } from '../../i18n';

const SidebarHeader = () => {
  const { t } = useTranslation();
  const logoSrc = `${process.env.PUBLIC_URL || ''}/logo-kaban.png`;

  return (
    <div className="sidebar-top">
      {/* Language switcher temporarily hidden — will return with multi-language support. */}

      <div className="sidebar-logo">
        <img src={logoSrc} alt={t('app.logoAlt')} />
      </div>

      <div className="sidebar-title">
        <h1>{t('app.title')}</h1>
        <p>{t('app.subtitle')}</p>
      </div>
    </div>
  );
};

export default SidebarHeader;
